import { theme } from "antd";

export const useBrandToken = () => {
    const { token } = theme.useToken();
    return token;
};
